import type { BannerPreset } from "@atrium/shared";
import { cn } from "../../lib/cn";
import { bannerBackground } from "../../lib/palette";

/** A community's banner: the uploaded image when there is one, otherwise its preset colour. */
export function CommunityBanner({
  url,
  preset,
  className,
  children,
}: {
  url: string | null | undefined;
  preset: BannerPreset | null | undefined;
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className={cn("relative overflow-hidden bg-surface-2", className)} style={url ? undefined : { background: bannerBackground(preset) }}>
      {url && <img src={url} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      {children}
    </div>
  );
}

/** Inline style that tints a community's subtree with its accent colour (see styles.css). */
export function communityAccentProps(accent: string | null | undefined) {
  return accent ? { "data-community-accent": "", style: { "--community-accent": accent } as React.CSSProperties } : {};
}
